export default "__VITE_ASSET__CK4twPQ4__"